import React from "react";


const Rewards = ()=> {

  return (
    <table className="overlay-modal-table text-center">
      <thead>
        <tr>
          <th>Place</th>
          <th>Seats</th>
          <th>Reward/Seat</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>1</td>
          <td>1</td>
          <td>300</td>
        </tr>

        <tr>
          <td>2</td>
          <td>1</td>
          <td>100</td>
        </tr>

        <tr>
          <td>3</td>
          <td>1</td>
          <td>70</td>
        </tr>

        <tr>
          <td>4-10</td>
          <td>7</td>
          <td>50</td>
        </tr>

        <tr>
          <td>11-50</td>
          <td>40</td>
          <td>25</td>
        </tr>

        <tr>
          <td>51-100</td>
          <td>50</td>
          <td>10</td>
        </tr>

      </tbody>
    </table>
  );
};

export default Rewards;
